import React from "react";

import NavIcon from "../../assets/icons/nav-icon.svg"

export class Navbar extends React.Component {
    toggleNavbar = () => {
        const navbar = document.getElementById("navbar");
        if (navbar) {
            if (navbar.className === "nav-bar") {
                navbar.className += " responsive";
            } else {
                navbar.className = "nav-bar";
            }
        }
    };

    handleScroll = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetId: string) => {
        event.preventDefault();
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
            window.history.replaceState(null, "", `#${targetId}`);
        }

        const navbar = document.getElementById("navbar");
        navbar?.classList.remove("responsive");
    };

    render() {
        return (
                <nav className="nav-bar" id="navbar">
                    <a href="#home" onClick={(e) => this.handleScroll(e, "home")}>
                        <img className="nav-logo" src={NavIcon} alt="CSCI 0150 home" style={{height: "100%", aspectRatio: "1"}}/>
                    </a>

                    <button className="icon" onClick={this.toggleNavbar}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                            strokeLinecap="round" strokeLinejoin="round">
                            <line x1="3" y1="6"  x2="21" y2="6"/>
                            <line x1="3" y1="12" x2="21" y2="12"/>
                            <line x1="3" y1="18" x2="21" y2="18"/>
                        </svg>
                    </button>

                    <a className="nav-link" href="#assignments" onClick={(e) => this.handleScroll(e, "assignments")}>Assignments</a>
                    <a className="nav-link" href="#lectures" onClick={(e) => this.handleScroll(e, "lectures")}>Lectures</a>
                    <a className="nav-link" href="#sections" onClick={(e) => this.handleScroll(e, "sections")}>Sections</a>
                    <a className="nav-link" href="#codealong" onClick={(e) => this.handleScroll(e, "codealong")}>Code-Alongs</a>
                    <a className="nav-link" href="#hours" onClick={(e) => this.handleScroll(e, "hours")}>Hours</a>
                    <a className="nav-link" href="#src" onClick={(e) => this.handleScroll(e, "src")}>SRC</a>
                    <a className="nav-link" href="#resources" onClick={(e) => this.handleScroll(e, "resources")}>Resources</a>
                    <a className="nav-link" href="#staff" onClick={(e) => this.handleScroll(e, "staff")}>Staff</a>
                </nav>
        );
    }
}
